import React, {useState} from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import swal from 'sweetalert';
import Logo from '../../Assets/images/hlogo.png'
import Loading from '../../Components/SelectValue/Loading';
import FormikControl from '../../Components/SelectValue/FormikControl';
import Button from '../../Components/SelectValue/Button';
import postService from '../../Services/post-service';
import { Divider } from '@mui/material';
// import Constant from '../../Constant'
function ConfirmPassForm() {
  const [loading, setLoading] = useState(false)
  const requestId = localStorage.getItem('frequestId')
    const initialValues = { 
        
        password: '',
        otp: '',

      }
      const validationSchema = Yup.object({
        otp: Yup.string()
        .matches(/^\d{6}$/, 'OTP must be a 6-digit number')
        .required('OTP is required'),
        password: Yup.string()
    .required('Password is required')
    .matches(
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]+$/,
      'Password must contain at least one letter, one digit, and one special character'
    ),
            
      })
      const onSubmit = values => {
        console.log('Form data', values)
        console.log('Saved data', JSON.parse(JSON.stringify(values)))
        setLoading(true)
        const { password, otp} = values
        postService.conForgetPassMail(otp,password,requestId).then(
          (response) => {
              console.log(response.data)
              setLoading(false)
             if(response.data.status === '2000'){
                swal("Password changed successfully!").then((result) => {
                    return   window.location.href = '/'
                  })

              // localStorage.setItem('token',response.data.data.token)
             
             }else{
              swal(response.data.description)
             
             }
             
            },
            (error) => {
              setLoading(false)
                return  swal('Error occured')
                .then((value) => {
                  window.location.reload()
                });
              }
        )
        // navigate('/dashboard')
      }

  return (
    <div className=' bg-white shadow-lg p-16 rounded-[16px]'>
    <Loading
      open={loading}
    />
        <div className=' '>
        <img src={Logo} width='152' height='40' className=" "  alt=" logo" /> 
            <p className=' mt-6 text-[18px] text-back-color2 mb-5 md:text-[40px] font-[500]'>Admin complete signup</p>
           
            <div className='  mt-5'>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                >
        {formik => (
        <Form>
        <p className=' my-3'>Enter your 6 digit otp  </p>
              <FormikControl
                control='input'
                label='OTP'
                name='otp'
                maxLength="6"
              /> 
            <div className=' mt-4'>
              <Divider/>
              <FormikControl
                control='password'
                label='Password'
                name='password'
              /> 
              </div>
               
              
              
              
               
             
              <div className=' grid grid-cols-1 mb-5 mt-6'>
              <Button
                name='Submit'
              />
              </div>
              
              
        </Form>
        )}
            </Formik>
            </div>
        </div>
    </div>
  )
}

export default ConfirmPassForm